/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon20Light = forwardRef('People1MinusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.501 6.499a4.499 4.499 0 1 1 8.998 0 4.499 4.499 0 0 1-8.998 0ZM10 3a3.499 3.499 0 1 0 0 6.997A3.499 3.499 0 0 0 10 3Z" }),
        React.createElement("path", { d: "M10 12.495a.5.5 0 0 1-.49.51c-1.284.025-2.942.174-4.265.816-.653.318-1.209.748-1.602 1.33C3.252 15.729 3 16.488 3 17.5a.5.5 0 0 1-1 0c0-1.188.299-2.147.815-2.91.513-.76 1.221-1.293 1.993-1.668 1.529-.743 3.371-.891 4.682-.917a.5.5 0 0 1 .51.49Z" }),
        React.createElement("path", { d: "M11.5 15a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" })));
});
